
<!-- 登陆页面-->
<template>
  <div class="container">
    <div class="logoImg">
      <img src="../assets/logo_y.gif" width="200px" >
    </div>
    <form v-model="loginForm" class="loginform">

      <div :style="{'visibility':usernameTip}" >
        <div class="usernameTip">
          请输入用户名
        </div>
        <div class="commonTip"></div>
      </div>

      <div style="display: flex;flex-wrap: wrap;margin-left: 20px;width: 80%;">
        <div style="z-index: 99999;">
          <img src="../assets/user1.jpg"  width="38px">
        </div>
        <input class="input " style="margin-left: -50px;width: 100%;" type="text" name="username" v-model="loginForm.username"  placeholder="用户名" @blur="changeVal" @focus="usernameStateChange"><br>
      </div>


      <div :style="{'visibility':passwordTip}">
        <div class="passwordTip">
          请输入密码
        </div>
        <div class="commonTip"></div>
      </div>
      <div style="display: flex;flex-wrap: wrap;margin-left: 20px;width: 80%;">
        <div style="z-index: 99999;">
          <img src="../assets/pwd1.jpg" class="" width="38px">
        </div>
        <input class="input " style="margin-left: -50px;width: 100%;" type="password" name="password" v-model="loginForm.password" placeholder="密码" @blur="changeVal" @focus="passwordStateChange"><br>


      </div>

      <div style="text-align: center;color: red;font-size: 15px;font-family: myMind" class="tip">{{tip}}</div>

      <div style="display: flex;flex-direction: row;width: 80%;margin-left: 20px;font-family: myMind;">
        <div style="width: 45%;">
          <input class="button" type="button" value="登录" @click="login">
        </div>
        <div style="width: 45%;margin-left: 10%">
          <input class="button" type="button" value="注册" @click="register">
        </div>
      </div>

      <div style="padding-top: 20px;text-align: center;margin-top: 20px;">
        <span style="cursor: pointer;font-family: myMind;color: cornflowerblue;margin-left: -30px;" @click="toMsgCodeLogin">短信验证码登录</span>
        <span style="cursor: pointer;font-family: myMind;color: cornflowerblue;margin-left: 20px;" @click="toResetPwd">忘记密码</span>
      </div>

    </form>



  </div>
</template>

<script>
  import  axios from 'axios';
  import jwt from 'jsonwebtoken';

  export default {
    name: "Login2",
    data:function(){
      return{
        loginForm:{
          username:'',
          password:''
        },
        tip:' ',
        usernameTip:'hidden',
        passwordTip:'hidden'
      }
    },
    mounted() {
      //
      window.screen.height;
      console.log('%c 窗口像素高：'+window.screen.height+' '+window.screen.availHeight+' '+window.document.documentElement.clientHeight,'color:red');
      document.body.style.height=window.document.documentElement.clientHeight;
    },
    methods:{
      login(){

        if(this.check()){
          axios.post(this.GLOBAL.serverURL+'api/login/',{
            username:this.loginForm.username,
            password:this.loginForm.password
          })
            .then(res=>{
              if(res.data.ret=='1000'){
                this.GLOBAL.token =res.data.token;  //将token存入全局变量中

                this.GLOBAL.userId =jwt.decode(res.data.token).id;

                //在IE 浏览器使用window.localStorage会报错
                window.localStorage.setItem('token',res.data.token);   //将token存入浏览器localStorage
                window.localStorage.setItem('username',jwt.decode(res.data.token).username); //将解码后的用户信息存入浏览器localStorage
                window.localStorage.setItem('id',jwt.decode(res.data.token).id); //将解码后的用户信息存入浏览器localStorage

                this.$router.push("/home");  //进入课程页
              }else{
                this.tip=res.data.msg;

              }
            })
            .catch(err=>{
              console.log('%c catch...','color:red;font-size:15px;');
              console.log(err);
            })
            .finally(res=>{

            });
        }
      },

      changeVal(){
        this.tip='';
      },

      register(){
        this.$router.push('/register');
      },
      toMsgCodeLogin(){
        this.$router.push('/msgCodeLogin');
      },
      toResetPwd(){
        this.$router.push('/resetPwd');
      },

      /**
       * 检查用户名和密码是否填写完整
       * @returns {boolean}
       */
      check(){

        if(this.loginForm.username!=''&&this.loginForm.password!=''){
          return true;
        }else{
          if(this.loginForm.username==''){
            console.log('请输入用户名：');
            this.usernameTip='visible';
          }
          if(this.loginForm.password==''){
            console.log('请输入密码：');
            this.passwordTip='visible';
          }
          return false;
        }
      },

      /**
       * 获得焦点 提示框状态重置
       */
      usernameStateChange(){
        this.usernameTip='hidden';
      },

      passwordStateChange(){
        this.passwordTip='hidden';
      }


    },

    beforeRouteLeave(to,from,next){
      to.meta.keepAlive = false;     //进入Home 主页   不缓存
      next();
    }
  }
</script>

<style scoped>


  @import "../assets/fonts/font.css";

  .container{
    background-image: url("../assets/bg4.jpg");
    background-repeat: no-repeat;
    /*background-attachment: fixed;*/
    background-size:  100% 100%;
    width: 100%;
    height: 100%;
    display: flex;
  }


  .loginform{
    position: relative;
    left: 25%;
    top: 31%;
    width: 40%;
    height: 50%;
    font-family: myMind;
  }
  .logoImg{
    position: relative;
    left: 20%;
    top: 20%;
    height: 50%;
  }

  .usernameTip{
    width: 60%;
    height: 20px;
    /*border: black solid 1px;*/
    border-radius: 4px;
    background-color: bisque;
    text-align: center;
    font-family: myMind;
    font-size: 10px;
    margin-left: 50px;
    line-height: 2;
  }


  .passwordTip{
    width: 60%;
    height: 20px;
    /*border: black solid 1px;*/
    border-radius: 4px;
    background-color: bisque;
    text-align: center;
    font-family: myMind;
    font-size: 10px;
    margin-left: 50px;
    line-height: 2;
  }

  .userImg{
    position: fixed;
    left: 50%;
    top: 20%;
    z-index: 999;
  }
  .username{
    position: fixed;
    left: 50%;
    top: 20%;
  }

  .pwdImg{
    position: fixed;
    left: 50%;
    top: 35%;
    z-index: 999;
  }
  .password{
    position: fixed;
    left: 50%;
    top: 35%;
  }
  .loginBtn{
    position: fixed;
    left: 50%;
    top: 55%;
  }

  .tip{
    margin-top: 20px;
  }
  .input{

    outline: 0;
    border: 1px solid rgba(255, 255, 255, 0.8);
    background-color: rgba(255, 255, 255, 0.7);
    width: 250px;
    border-radius: 30px;
    padding: 10px 15px;
    margin: 0 auto 10px auto;
    display: block;
    text-align: center;
    font-size: 18px;
    color: black;
    -webkit-transition-duration: 0.25s;
    transition-duration: 0.25s;
    font-weight: 300;
    font-family: myMind;

  }
  .button{

    outline: 0;
    border: 1px solid rgba(85, 85, 87, 0.5);
    background-color: rgba(255, 255, 255, 0.3);
    width: 100%;
    border-radius: 30px;
    padding: 10px 15px;
    /*margin: 0 auto 10px auto;*/
    display: block;
    text-align: center;
    font-size: 18px;
    color: black;
    -webkit-transition-duration: 0.25s;
    transition-duration: 0.25s;
    font-weight: 800;
    margin-left: -10px;
    font-family: myMind;
  }
  .commonTip{
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 20px solid #ffe4c4;
    margin-left: 80px;
    margin-top: -10px;
  }
  @media screen and (max-height: 400px){
    .logoImg{
      position: relative;
      left: 10%;
      top: 5%;
      height: 30%;
    }
    .loginform{
      position: relative;
      left: 11%;
      top: 21%;
      width: 60%;
      height: 50%;
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/Login.vue